import React from 'react'

const NotFoundPage = () => {
  return (
    <div className="error_page" style={{ marginTop: 100 }}>
      <div className="container">
        <div className="row">
          <div className="col-md-10 col-md-offset-1 col-sm-12 col-xs-12 text-center">
            <div className="error_page_cntnt">
              <h2>
                <span>4</span>
                <span>0</span>
                <span>4</span>
              </h2>
              <h3>Üzgünüz, Bu Sayfa Mevcut Değil :(</h3>
              <p>
                Veya Giriş yaptıktan sonra tekrar deneyin
              </p>
              <div className="error_page_mail_wrapper">
              </div>
              <a href='/'>
                Geri Don
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
}

export default NotFoundPage